import { render, staticRenderFns } from "./PopDuzenle.vue?vue&type=template&id=21479f4d&scoped=true&"
import script from "./PopDuzenle.vue?vue&type=script&lang=js&"
export * from "./PopDuzenle.vue?vue&type=script&lang=js&"
import style0 from "./PopDuzenle.vue?vue&type=style&index=0&id=21479f4d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21479f4d",
  null
  
)

export default component.exports